module.exports = __webpack_public_path__ + "static/media/lb.bdba8149.svg";